var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.1484C11 8.09375 10.4922 5.71875 8.44531 5.71875C7.8125 6.33594 6.95312 6.71875 6 6.71875C5.04688 6.71875 4.1875 6.33594 3.55469 5.71875C1.50781 5.71875 1 8.09375 1 10.1484C1 11.2891 1.75 12.2188 2.66406 12.2188H9.33594C10.25 12.2188 11 11.2891 11 10.1484ZM9 3.21875C9 1.5625 7.65625 0.21875 6 0.21875C4.34375 0.21875 3 1.5625 3 3.21875C3 4.875 4.34375 6.21875 6 6.21875C7.65625 6.21875 9 4.875 9 3.21875Z",
    fill: "#B3B3B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlco);
export default __webpack_public_path__ + "static/media/alco.9dfef19bd6c7fe99a28e4b62a7f2fb79.svg";
export { ForwardRef as ReactComponent };